var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyStreams = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 153,
  height: 153,
  viewBox: "0 0 153 153",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 153,
  height: 153,
  rx: 76.5,
  fill: "#E7EAED"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.0001 49.8139C39.0001 48.2598 40.2599 47 41.814 47H111.817C113.371 47 114.631 48.2598 114.631 49.8139V94.6066C114.631 96.1607 113.371 97.4205 111.817 97.4205H41.814C40.2599 97.4205 39.0001 96.1607 39.0001 94.6066V49.8139Z",
  fill: "#CED4DA",
  stroke: "#CED4DA",
  strokeWidth: 4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.9585 106.243H91.1856",
  stroke: "#CED4DA",
  strokeWidth: 4,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M73 66.8427C73 66.0492 73.8797 65.5718 74.545 66.0042L81.7101 70.6616C82.3168 71.0559 82.3168 71.9441 81.7101 72.3384L74.545 76.9958C73.8797 77.4282 73 76.9508 73 76.1573V66.8427Z",
  fill: "white",
  fillOpacity: 0.8
})));
export { SvgEmptyStreams as ReactComponent };
export default __webpack_public_path__ + "static/media/emptyStreams.e6c6877b.svg";